import React from 'react';

export const Logo = () => (
  <svg viewBox="0 0 366 422">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-141.000000, -51.000000)">
        <g transform="translate(113.000000, 51.000000)">
          <polygon
            fill="#FFFFFF"
            points="211 0 393.73136 105.5 393.73136 316.5 211 422 28.2686398 316.5 28.2686398 105.5"
          ></polygon>
          <polygon
            fill="#006298"
            points="211 16 380.740979 114 380.740979 310 211 408 41.2590209 310 41.2590209 114"
          ></polygon>
          <polygon
            fill="#E0004D"
            points="211 278.085938 372.080725 278.085938 372.080725 305 211 398 49.9192749 305 49.9192749 278.085938"
          ></polygon>
          <polygon
            fill="#FA6600"
            points="211 258.085938 372.080725 258.085938 372.080725 285 211 378 49.9192749 285 49.9192749 258.085938"
          ></polygon>
          <polygon
            fill="#F2A900"
            points="211 238.085938 372.080725 238.085938 372.080725 265 211 358 49.9192749 265 49.9192749 238.085938"
          ></polygon>
          NotificationsIcon{' '}
          <polygon
            fill="#FFC72C"
            points="211 218.085938 372.080725 218.085938 372.080725 245 211 338 49.9192749 245 49.9192749 218.085938"
          ></polygon>
          <polygon
            fill="#71C5E8"
            transform="translate(211.000000, 114.019531) scale(1, -1) translate(-211.000000, -114.019531) "
            points="211 82.0390625 372.080725 26.0859375 372.080725 108.953125 211 201.953125 49.9192749 108.953125 49.9192749 26.0859375"
          ></polygon>
          <polygon
            fill="#006298"
            transform="translate(210.999275, 211.451362) scale(1, -1) translate(-210.999275, -211.451362) "
            points="211.039627 105 372.079275 198.019242 372.079275 224.926441 211.039627 317.902725 49.9192749 224.926441 49.9192749 198.019242"
          ></polygon>
          <polygon
            fillOpacity="0.3"
            fill="#000000"
            points="211 105 211.082275 119 211.082275 305 211 398 49.9192749 305 49.9192749 197.976284"
          ></polygon>
          <polygon
            fill="#00263E"
            transform="translate(211.074646, 135.429687) rotate(45.000000) translate(-211.074646, -135.429687) "
            points="189.454148 113.848182 248.338923 98.1654105 232.4077 156.868307 173.810369 172.693965"
          ></polygon>
          <polygon
            fill="#FA6600"
            transform="translate(211.082275, 146.021484) rotate(45.000000) translate(-211.082275, -146.021484) "
            points="196.93044 131.919432 235.298784 121.774593 224.920403 159.975967 186.865767 170.268376"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);
